export default __webpack_public_path__ + "static/media/200_1 1.8fca2785.svg";